import { Button, Dialog, DialogContent, DialogTitle, Typography, Box, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import PropTypes from 'prop-types';
import SlideIconButton from '../../../../reusable-components/basic-buttons/SlideIconButton';

ReportTimeoutEmailPopup.propTypes = {
  close: PropTypes.func,
  getReport: PropTypes.func,
};

export default function ReportTimeoutEmailPopup({ close, getReport }) {
  const [loading, setLoading] = useState(false);

  return <Dialog
    open
    onClose={(event, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      close();
    }}
    maxWidth="sm"
    fullWidth
  >
    <DialogContent>
      <DialogTitle sx={{ textAlign: "center" }}>
        <SlideIconButton text="Back to schedule" icon="mingcute:left-fill" onClick={close} floatLeft />Report Email
      </DialogTitle>

      <Typography sx={{ pb: 2, pt: 1, textAlign: 'center' }} variant="h6" color="info.main">
        <Box>The report is too large to generate.</Box>
        <Box>Would you like to receive this report as an email?</Box>
      </Typography>

      <Stack direction="row" sx={{ justifyContent: "center", display: "flex" }} spacing={2}>
        <LoadingButton loading={loading} variant="contained" onClick={() => { setLoading(true); getReport(); }} color="primary">
          Send Email
        </LoadingButton>
        <Button variant="outlined" onClick={close} color="error">
          Cancel
        </Button>
      </Stack>
    </DialogContent>
  </Dialog>;
}
